import { MAPA_CARGOS } from '@/components/Configuracao/mapaCargos/mapaCargosData'
import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'
import {
  resolveMapaCargo,
  type MapaCargoOverridesMap,
} from '@/components/Configuracao/mapaCargos/mapaCargosMerge'

export const mapaCargosSelectOptions = MAPA_CARGOS.map((cargo) => ({
  value: cargo.id,
  label: cargo.titulo,
}))

export function getMapaCargoById(
  id: string | undefined | null,
  overrides: MapaCargoOverridesMap = {},
): MapaCargo | undefined {
  if (!id?.trim()) return undefined
  return resolveMapaCargo(id, MAPA_CARGOS, overrides)
}

export function formatMapaCargoDescricao(cargo: MapaCargo): string {
  const sections = cargo.secoes
    .map((secao) => {
      const bullets = secao.atividades.map((item) => `• ${item}`).join('\n')
      return `${secao.titulo}\n${bullets}`
    })
    .join('\n\n')

  return `${cargo.titulo}\n\n${sections}`
}

export function applyMapaCargoToFormValues(
  cargoId: string,
  current: Record<string, string>,
  overrides: MapaCargoOverridesMap = {},
): Record<string, string> {
  const cargo = getMapaCargoById(cargoId, overrides)
  if (!cargo) return current

  return {
    ...current,
    mapaCargoId: cargoId,
    funcaoCargo: cargo.titulo,
    descricaoEscopo: formatMapaCargoDescricao(cargo),
  }
}
